import React from 'react';
import ReactDOM from 'react-dom/client';
import { ReactSession } from 'react-client-session';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as bsc from '@binance-chain/bsc-use-wallet'
 


const root = ReactDOM.createRoot(document.getElementById('root'));
ReactSession.setStoreType("localStorage");

if(ReactSession.get("network") == undefined){
  ReactSession.set("network", {
    "networkname":"BSC",
    "chainID":56,
    "rpc":"https://bsc-dataseed1.ninicoin.io",
    "name":"Binance Smart Chain Mainnet",
    "symbol":"BNB",
    "blockexplorer":"https://bscscan.com",
    "routers":[{
        "name":"Pancakeswap",
        "address":"0x10ED43C718714eb63d5aA57B78B54704E256024E"
     },{
        "name":"ApeSwap",
        "address":"0xcF0feBd3f17CEf5b47b0cD257aCf6025c5BFf3b7"
     },{
        "name":"Biswap",
        "address":"0x3a6d8cA21D1CF76F653A67577FA0D27453350dD8"
     }
     
    ]  
});
}

if(ReactSession.get("refwallet") == undefined){
  ReactSession.set("refwallet","0x0000000000000000000000000000000000000000");
}

const chainId = ReactSession.get("network").chainID;
const rpcUrl = ReactSession.get("network").rpc;


root.render(
  <React.StrictMode>
    <bsc.UseWalletProvider
            chainId={chainId}
            connectors={{
              walletconnect: { rpcUrl: rpcUrl  },
            }}
          >
        <App />  
    </bsc.UseWalletProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
